import { makeStyles, tokens } from "@fluentui/react-components";

export const useSettingsStyles = makeStyles({
  linksList: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    marginTop: "12px",
  },
  linksItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "6px 4px",
    color: tokens.colorBrandForeground1,
    textDecoration: "none",
    fontSize: tokens.fontSizeBase300,

    "&:hover": {
      textDecoration: "underline",
      backgroundColor: tokens.colorNeutralBackground1Hover,
      borderRadius: tokens.borderRadiusMedium,
    },
  },
  linksIcon: {
    color: tokens.colorBrandForeground1,
    flexShrink: 0,
  },
});
